import React from 'react';
import { updateBannerVariables, createBannerVariables } from '@api/graphql/types';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import BannerSizes from '@modules/BannerPlace/sizes';
import Form from '@components/Form/Form';

type formDataType = updateBannerVariables | createBannerVariables;

type Props = {
    formData: formDataType,
    onSubmit: (formData: formDataType) => Promise<any>,
    redirectFunction?: (submitResponse: any) => string | undefined,
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: formDataType;
}

class BannerPlaceForm extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            formData: this.props.formData,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({formData: props.formData});
    }

    private validate(): boolean {
        return true;
    }

    private onChange = (formData: formDataType) => {
        this.setState({formData});
    }

    private bannerSize = (type: 'desktop' | 'mobile'): string => {
        if (this.state.formData.banner_place_ids[0]) {
            if (BannerSizes[this.state.formData.banner_place_ids[0]]) {
                const size = BannerSizes[this.state.formData.banner_place_ids[0]];
                if (size && !!this.props.intl.messages[`module.banner.image_url_${type}.hint`]) {
                    return this.props.intl.formatMessage({id: `module.banner.image_url_${type}.hint`}, {size: size[type]});
                }
            }
        }
        return this.props.intl.formatMessage({id: 'module.banner.selectBannerPlace'});
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text', props: {required: true}},
            {name: 'active_from', type: 'datetime'},
            {name: 'active_to', type: 'datetime'},
            {name: 'url', type: 'text', props: {required: true}},
            {name: 'url_target', type: 'bannerurltarget', props: {required: true}},
            {name: 'banner_place_ids', type: 'bannerplaceselect'},
            {name: 'image_url_desktop', type: 'imageselector', props: {prefix: 'banners', hint: this.bannerSize('desktop'), required: true}},
            {name: 'image_url_mobile', type: 'imageselector', props: {prefix: 'banners', hint: this.bannerSize('mobile'), required: true}},
            {name: 'is_active', type: 'checkbox'},
            {name: 'priority', type: 'number'},
        ];

        return (
            <Form
                fields={[{id: 'default', fields}]}
                intlPrefix={'module.banner'}
                onSubmit={this.props.onSubmit}
                formData={this.state.formData}
                redirectPath={this.props.redirectFunction ? this.props.redirectFunction : Path.banner}
                validate={this.validate}
                onChange={this.onChange}
            />
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(BannerPlaceForm);



// WEBPACK FOOTER //
// ./src/modules/Banner/components/BannerForm.tsx